export const translations = {
	'Data Source': {},
	'Datasource grid': {
		no: 'Datakilde tabell',
	},
};
